
import * as React from 'react';
import { PPMFeatures } from '../../../../store/Tenant';
import "./SwitchTrialDialog.css";

export const FeaturesList = (props: { features: PPMFeatures[], isNew: boolean }) => {
    return <ul className='switch-trial-features-list'>
        {
            PPMFeatures
                .getFeaturesValues()
                .filter(_ => props.features.includes(_))
                .map(_ => <li key={_.toString()} className={`${props.isNew ? "new" : "lost"}`}>
                    <span>{PPMFeatures.getTitle(_)}</span>
                </li>)
        }
    </ul>
}